import { AxiosError } from "axios";
import { handleApiError } from "./instanceApi";
import { moodleInstanceApi } from "./moodleInstanceApi";
import { resetPasswordInstanceApi } from "./moodleInstanceApi";

export const resetPassword = async (params: any) => {
  try {
    const response = await resetPasswordInstanceApi.get('',{
      params: {
        ...params,
      }
    })
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};

export const requestForgotPassword = async (username: string) => {
  try {
    const response = await moodleInstanceApi.post(
      "/webservice/rest/server.php",
      {
        params: {
          wsfunction: "local_forgotpassword_request_forgot_password",
          username: username,
        },
      }
    );
    return response?.data;
  } catch (error) {
    return handleApiError(error as AxiosError);
  }
};
